import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { isPersonal } from 'data/channels/record'
import { record as ChannelsRecord } from 'data/channels'

import ModalBody from 'components/Utils/Modal/Body'
import LeaveAndExit from './LeaveAndExit'
import ActivitySetting from './ActivitySetting'
import ChannelsSettingsGeneralManagement from './Management'

class ChannelsSettingsGeneral extends Component {
  static propTypes = {
    channel: PropTypes.instanceOf(ChannelsRecord).isRequired,
    canManage: PropTypes.bool.isRequired,
    onModalClose: PropTypes.func,
  }

  render() {
    const { channel, canManage, onModalClose, closeModal } = this.props

    if (isPersonal(channel)) {
      return <div className="padding-largest" />
    }

    return (
      <ModalBody>
        <ChannelsSettingsGeneralManagement
          channelId={channel.id}
          onClose={onModalClose}
          canManage={canManage}
        />

        <ActivitySetting channelId={channel.id} closeModal={closeModal} />

        <LeaveAndExit
          channelId={channel.id}
          onClose={this.props.onClose}
          canManage={canManage}
        />
      </ModalBody>
    )
  }
}

export default ChannelsSettingsGeneral
